import { useEffect } from 'react';
import { useDashboardStore } from '@budget/core';
import { dataSource } from './source';

const SHEET_POLL_MS = 60 * 60 * 1000;

export function useDashboard() {
  const state = useDashboardStore();
  useEffect(() => {
    if (!state.lastFetched && !state.isLoading) {
      void state.refresh(dataSource);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let alive = true;
    let timer: ReturnType<typeof setInterval> | null = null;

    const tick = () => {
      const current = useDashboardStore.getState();
      if (!alive || current.isLoading) return;
      void current.refresh(dataSource);
    };

    const start = () => {
      if (timer != null) return;
      timer = setInterval(tick, SHEET_POLL_MS);
    };

    const stop = () => {
      if (timer != null) {
        clearInterval(timer);
        timer = null;
      }
    };

    const onVisibility = () => {
      if (document.visibilityState === 'hidden') {
        stop();
      } else {
        tick();
        start();
      }
    };

    if (document.visibilityState !== 'hidden') start();
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      alive = false;
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  return {
    data: state.data,
    isLoading: state.isLoading,
    error: state.error,
    lastFetched: state.lastFetched,
    refresh: () => state.refresh(dataSource),
  };
}
